import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CardViewPayment = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const checkoutId = pathSegments[pathSegments.length - 1];

  useEffect(() => {
    if (!checkoutId) return;
    console.log("checkoutId", checkoutId);

    window.wpwlOptions = {
      applePay: {
        displayName: "fawazlaw",
        total: { label: "COMPANY, INC." },
        supportedNetworks: ["mada", "masterCard", "visa"]
      }
    };

    // Inject paymentWidgets.js script
    const script = document.createElement('script');
    script.src = `https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
    console.log("script", script);

  
    const style = document.createElement('style');
    style.innerHTML = `
      .wpwl-apple-pay-button {
        -webkit-appearance: -apple-pay-button !important;
      }
    `;
    document.head.appendChild(style);

   
    return () => {
      document.body.removeChild(script);
      document.head.removeChild(style);
    };
  }, [checkoutId]);

  if (!checkoutId) {
    return (
      <div className="text-red-600 font-bold text-center mt-10">
        ❌ Missing checkoutId in URL
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-center pt-8 pb-11">
      <h1 className="text-[20px] font-bold pb-4">Apple Pay Payment</h1>
      <form
        action={`https://demo-two.keytime.sa/api/payment/Paymentstatus`}
        className="paymentWidgets"
        data-brands="APPLEPAY"
      ></form>
    </div>
  );
};

export default CardViewPayment;
